import { runCommand } from './command';

// TODO use fs for cross platform 🤔

export async function move(source: string, destination: string) {
  return runCommand(`mv ${source} ${destination}`);
}

export async function rimRaf(dir: string) {
  return runCommand(`rm -rf ${dir}`);
}

export async function writeFile(name: string, content: string) {
  return runCommand(`echo "${content}" > ${name}`);
}
